import { type VariantProps, cva } from 'class-variance-authority';
import { type PrimitiveProps } from 'radix-vue';

export const textLinkVariants = cva(
	'cursor-pointer font-sans underline underline-offset-4 transition-colors',
	{
		variants: {
			variant: {
				default: 'decoration-white-dark-4 hover:decoration-primary',
				dark: 'decoration-primary-light-1 hover:decoration-white',
				'primary-light-1': 'decoration-primary-light-1 hover:decoration-primary'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

export type TextLinkVariantProps = VariantProps<typeof textLinkVariants>;
export interface TextLinkProps extends PrimitiveProps {
	class?: string;
	variant?: TextLinkVariantProps['variant'];
}
